"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewStorePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var react_router_dom_1 = require("react-router-dom");
var ViewStorePage = function () {
    var _a;
    var locationBankID = (_a = process.env.LOCATION_BANK_CLIENT_ID) !== null && _a !== void 0 ? _a : "";
    var navigate = (0, react_router_dom_1.useNavigate)();
    // useEffect(() => {
    //   if (window.location.pathname.endsWith("/")) {
    //     console.log("window.location.pathname", window.location.pathname);
    //     const newPath = window.location.pathname.slice(0, -1) + window.location.search;
    //     navigate(newPath);
    //   }
    // }, []);
    return (react_1.default.createElement("div", { className: "flex justify-center" },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("script", { async: true, defer: true, type: "text/javascript", src: "https://locationbank.net/Public/LocationDetails?id=".concat(locationBankID) })),
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement("div", { id: locationBankID, className: "LB_LocationDetails", style: { height: "100%", width: "100%" } }))));
};
exports.ViewStorePage = ViewStorePage;
